// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageFieldEmpty__image-ea55ad {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  overflow: hidden;
  background-color: var(--base-20);
}

.ImageFieldEmpty__round-f2a5a8 {
  border-radius: 50%;
}

.ImageFieldEmpty__square-f78bed {
  border-radius: 32px;
}

.ImageFieldEmpty__camera-icon-c371b1 {
  fill: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/ImageField/ImageFieldEmpty/ImageFieldEmpty.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,6BAAA;AACF","sourcesContent":[".image {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 120px;\n  height: 120px;\n  overflow: hidden;\n  background-color: var(--base-20);\n}\n\n.round {\n  border-radius: 50%;\n}\n\n.square {\n  border-radius: 32px;\n}\n\n.camera-icon {\n  fill: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `ImageFieldEmpty__image-ea55ad`,
	"round": `ImageFieldEmpty__round-f2a5a8`,
	"square": `ImageFieldEmpty__square-f78bed`,
	"camera-icon": `ImageFieldEmpty__camera-icon-c371b1`,
	"cameraIcon": `ImageFieldEmpty__camera-icon-c371b1`
};
module.exports = ___CSS_LOADER_EXPORT___;
